import { wrap } from "comlink";

const noidWorkerAPI = new Worker(
  new URL("./workers/noidWorker.ts", import.meta.url)
);
const noidWorkerApi = wrap(noidWorkerAPI);

export default noidWorkerApi;
